import { CompanyContacts } from './company-contacts';
import { ReportSubscriptionTypesEnum } from '../../enum/report-subscription-types.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateEditCompanyContactCommand {
  CompanyContacts: CompanyContacts[];
  ContractId: string;
  ReceiveInspectionReports: boolean;
  ScheduledReportStartDate: string;
  ReportSubscriptionTypes: ReportSubscriptionTypesEnum;
  ContactTypeId: string;
}


